export default "__VITE_ASSET__1e8f25ba__"